import * as React from 'react';

import Filter from '../../components/filters/filter';
import ClearAll from '../../components/filters/clear-all';


import { FiltersContainerViewProps } from '../../components/filters/container';
import { CalendarDeviceMode } from '../../classes/calendar';
import MonthSelectionDropdown from '../../components/month-selection/dropdown';

const FiltersListView: React.StatelessComponent<FiltersContainerViewProps> = props => {
    return (
        <ul className="ace-cal-filters-list ace-filters-list">
            {
                !(props.deviceMode === CalendarDeviceMode.MOBILE || props.filtersAlwaysModal) &&
                <li className="ace-cal-filter ace-filter">
                    <MonthSelectionDropdown />
                </li>
            }
            <Filter propertyToFilter="location" filterName={props.text.venueFilterLabelText} noSelectionText={props.text.venueSelectAllDropdownOption} />
            <Filter propertyToFilter="name" filterName={props.text.productionFilterLabelText} noSelectionText={props.text.productionSelectAllDropdownOption} />
            <Filter propertyToFilter="categories" filterName={props.text.categoryFilterLabelText} noSelectionText={props.text.categorySelectAllDropdownOption} />
            <li className="ace-cal-clear-filters ace-clear-filters">
                <ClearAll />
            </li>
        </ul>
    )
}

const FiltersContainerView: React.StatelessComponent<FiltersContainerViewProps> = props => {
    return (
        (props.deviceMode === CalendarDeviceMode.MOBILE || props.filtersAlwaysModal) ?
            <div id="filters-dialog" className="ace-cal-modal-container">
                <div tabIndex={-1} data-a11y-dialog-hide className="ace-cal-modal-bg"></div>
                <div role="dialog" className="">
                    <div className="ace-cal-modal">
                        <div className="ace-cal-modal-inner">
                            <h3>{props.text.openFiltersButtonText}</h3>
                            <FiltersListView {...props}></FiltersListView>
                            <button type="button" data-a11y-dialog-hide aria-label={props.text.filterCloseButtonLabel} className="ace-cal-modal-close"></button>
                        </div>
                    </div>
                </div>
            </div> :
            <div className="ace-cal-filters ace-filters" aria-hidden="false">
                <FiltersListView {...props}></FiltersListView>
            </div>
    );
}

export default FiltersContainerView;